import React from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { v4 as uuidv4 } from 'uuid';
import Header from "../Header/Header.jsx"
import Bridge from "../../../services/Bridge.js"
import style from "./style.module.css";

const USERNAME_REGEX = /^[a-zA-Z0-9_]{3,16}$/;
const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
const REGISTRATION_CODE_REGEX = /^[A-Za-z0-9]{8}$/;

const Register = ({ handleAuth, auth, user }) => {

    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();

    const bridge = new Bridge();

    const [email, setEmail] = React.useState("");
    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const [registrationCode, setRegistrationCode] = React.useState("");

    React.useEffect(()  => {
        if (auth) navigate("/minecraft");

    // eslint-disable-next-line
	}, []);

    const handleSendRegisterCode = async () => {

        const v1 = EMAIL_REGEX.test(email);
        const v2 = USERNAME_REGEX.test(username);
        const v3 = PASSWORD_REGEX.test(password);
        const v4 = password === confirmPassword;

        if (!v1) {
            enqueueSnackbar("Wrong email form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v2) {
            enqueueSnackbar("Wrong username form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v3) {
            enqueueSnackbar("Wrong password form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v4) {
            enqueueSnackbar("Password do not match", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        try {
            await bridge.POST("sendRegistrationCode", {
                email: email,
                username: username
            });

            enqueueSnackbar("Your code is in you game chat", {
              variant: "success",
              autoHideDuration: 5000
            });

        } catch (error) {
            enqueueSnackbar(error, {
              variant: "error",
              autoHideDuration: 5000,
            });
        };
    };

    const handleRegister = async () => {

        const v1 = EMAIL_REGEX.test(email);
        const v2 = USERNAME_REGEX.test(username);
        const v3 = PASSWORD_REGEX.test(password);
        const v4 = password === confirmPassword;
        const v5 = REGISTRATION_CODE_REGEX.test(registrationCode);

        if (!v1) {
            enqueueSnackbar("Wrong email form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v2) {
            enqueueSnackbar("Wrong username form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v3) {
            enqueueSnackbar("Wrong password form", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v4) {
            enqueueSnackbar("Password do not match", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        if (!v5) {
            enqueueSnackbar("Registration code is not valid", {
                variant: "error",
                autoHideDuration: 5000,
            });
            return;
        };

        try {
            await bridge.POST("register", {
                email: email,
                username: username,
                password: password,
                registrationCode: registrationCode,
                id: uuidv4()
            });

            enqueueSnackbar("You've been successfully registered", {
              variant: "success",
              autoHideDuration: 3000,
              onEntered: () => {
                handleAuth();
                navigate("/minecraft");
              }
            });

        } catch (error) {
            enqueueSnackbar(error, {
              variant: "error",
              autoHideDuration: 5000,
            });
        };
    };

    return (
        <div>
            <Header />
            <div className={style.rootDiv}>
                <div className={style.stepsAndRegister}>
                    <div className={style.stepBox}>
                        <p>1. Enter your email</p>
                        <p>2. Enter your Minecraft username</p>
                        <p>3. Create and confirm your password</p>
                        <p>4. Join the server and go to the Lobby</p>
                        <p className={style.greySmallText}>- Make sure you are already connected to our server and in the "Lobby"</p>
                        <p>5. Click “Send Code”</p>
                        <p className={style.greySmallText}>- Once in the Lobby, click "Send Code" to receive an 8-digit verification code in Minecraft.</p>
                        <p>6. Enter the code from Minecraft</p>
                        <p>7. Complete registration</p>
                    </div>
                    <div className={style.registerBox}>
                        <div className={style.inputBox}>
                            <svg viewBox="0 0 512 512">
                                <path d="M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"/>
                            </svg>
                            <input placeholder="E-mail" type="email" value={email} onChange={event => setEmail(event.target.value)}/>
                        </div>
                        <div className={style.inputBox}>
                            <svg viewBox="0 0 448 512">
                                <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/>
                            </svg>
                            <input placeholder="In-game Username" value={username} onChange={event => setUsername(event.target.value)}/>
                        </div>
                        <div className={style.inputBox}>
                            <svg viewBox="0 0 512 512">
                                <path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"/>
                            </svg>
                            <input placeholder="Password" type="password" value={password} onChange={event => setPassword(event.target.value)}/>
                        </div>
                        <div className={style.inputBox}>
                            <svg viewBox="0 0 512 512">
                                <path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"/>
                            </svg>
                            <input placeholder="Confirm Password" type="password"  value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)}/>
                        </div>
                        <div className={style.inputBox}>
                            <svg viewBox="0 0 512 512">
                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                            </svg>
                            <input placeholder="Code" type="text"  value={registrationCode} onChange={event => setRegistrationCode(event.target.value)}/>
                            <button className={style.sendCodeBtn} onClick={handleSendRegisterCode}>Send code</button>
                        </div>
                        <div className={style.login}>
                            <p>Already have an account?</p>
                            <p className={style.loginBtn} onClick={() => navigate("/minecraft/login")}>Login</p>
                        </div>
                </div>
                </div>
                <button className={style.registerBtn} onClick={handleRegister}>Register</button>
            </div>
        </div>
    );
};

export default Register;